/**
 * ClawInstall security (`/security`) — eager half of the route. Registers the
 * file route with its SSR head only; the page component and every design /
 * seam import live in `security.lazy.tsx` so they load with this route and
 * never land in the always-loaded `main` chunk (the `entryChunkGzipKb` budget,
 * CLA-645). Mounted outside the `/clawinstall` layout (trailing-underscore
 * escape) so the frame's `<main>` is the only main landmark.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";
import { identityFromHeadCtx, publicPageHead } from "~/lib/clawinstall-marketing-head.ts";

/** SSR head for `/security`: identity-scoped title/canonical, host-agnostic facts description. @since 1.0.0 */
export const securityHead = (ctx?: Parameters<typeof identityFromHeadCtx>[0]) => {
  const identity = identityFromHeadCtx(ctx);
  return publicPageHead({
    path: "/security",
    title: `Security — ${identity.displayName}`,
    description:
      "No public ports, signed requests, secrets encrypted at rest, device approval, encrypted backups and a dedicated server for every agent.",
    identity,
  });
};

export const Route = createFileRoute("/clawinstall_/security")({
  head: securityHead,
});
